var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Row',{staticClass:"flex-centerize py-3 width-100 close-extension-drawer-footer-container"},[_c('AnemicButton',{staticClass:"close-builder-button px-9",attrs:{"tile":""},on:{"click":_vm.closeBuilderDrawer}},[_vm._v(" Close builder "),_c('AppIcon',{staticClass:"ml-3",attrs:{"name":"close-builder-drawer"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }